import React from 'react';
import ToggleSwitch from './ToggleSwitch';

interface ComingSoonSettingProps {
  title: string;
  description: string;
  icon: string;
  comingSoonText: string;
  showToggle?: boolean;
  toggleChecked?: boolean;
  onToggleChange?: (checked: boolean) => void;
}

const ComingSoonSetting: React.FC<ComingSoonSettingProps> = ({
  title,
  description,
  icon,
  comingSoonText,
  showToggle = false,
  toggleChecked = false,
  onToggleChange,
}) => {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-gray-50 rounded-lg opacity-60">
        <div className="flex items-start justify-between">
          <div className="flex items-start space-x-3 flex-1">
            <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-gray-400 text-sm">{icon}</span>
            </div>
            <div className="text-left min-w-0 flex-1">
              <p className="font-medium text-gray-700 text-sm mb-1">{title}</p>
              <p className="text-xs text-gray-500 leading-relaxed">
                {description}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-end space-y-2 ml-4">
            {showToggle && (
              <ToggleSwitch
                checked={toggleChecked}
                onChange={onToggleChange || (() => {})}
                disabled={true}
              />
            )}
            <span className="text-xs text-gray-400 italic text-right">
              {comingSoonText}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonSetting;
